import Vue from "vue";
import Router from "vue-router";
import Layout from "@/views/layout/Layout";

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};

Vue.use(Router);
export const constantRouterMap = [
  {
    path: "/to-be-built",
    component: Layout,
    redirect: "/to-be-built",
    name: "to-be-built",
    meta: {
      title: "待建",
      icon: "nested"
    },
    children: [
      {
        path: "index",
        component: () => import("@/views/under-contribute/index"),
        name: "to-be-built-index",
        meta: {
          title: "建设中..."
        }
      }
    ]
  },
  {
    path: "/401",
    component: () => import("@/views/error-page/401"),
    hidden: true
  },
  {
    path: "",
    component: Layout,
    redirect: "/index",
    children: [
      {
        path: "/index",
        component: () => import("@/views/dashboard/index.vue"),
        name: "Dashboard",
        meta: {
          title: "index",
          icon: "dashboard",
          isShowSideBar: true,
          noCache: true,
          keepAlive: false, // 组件不需要缓存
          affix: true
        }
      }
    ]
  },
  {
    path: "/favorite",
    component: Layout,
    redirect: "/favorite/index",
    children: [
      {
        path: "/favorite/index",
        component: () => import("@/views/favorite/index.vue"),
        name: "favorite"
      }
    ]
  },
  {
    path: "/inquiry-price-goods",
    redirect: "/inquiry-price-goods/index",
    component: Layout,
    children: [
      {
        path: "/inquiry-price-goods/index",
        component: () => import("@/views/dashboard/inquiry-price-goods.vue"),
        name: "inquiryPriceGoods"
        // meta: {
        //   title: "inquiryPriceGoods",
        //   icon: "dashboard",
        //   isShowSideBar: true,
        //   noCache: true,
        //   keepAlive: false, // 组件不需要缓存
        //   affix: true
        // }
      }
    ]
  },
  {
    path: "/inquiry-price-goods-cloud-rent",
    redirect: "/inquiry-price-goods-cloud-rent/index",
    component: Layout,
    children: [
      {
        path: "/inquiry-price-goods-cloud-rent/index",
        component: () =>
          import("@/views/dashboard/inquiry-price-goods-cloud-rent.vue"),
        name: "inquiryPriceGoods"
        // meta: {
        //   title: "inquiryPriceGoods",
        //   icon: "dashboard",
        //   isShowSideBar: true,
        //   noCache: true,
        //   keepAlive: false, // 组件不需要缓存
        //   affix: true
        // }
      }
    ]
  },
  {
    path: "/inquiry-price-plans-cloud-rent",
    redirect: "/inquiry-price-plans-cloud-rent/index",
    component: Layout,
    children: [
      {
        path: "/inquiry-price-plans-cloud-rent/index",
        component: () =>
          import("@/views/dashboard/inquiry-price-plans-cloud-rent.vue"),
        name: "inquiryPlans"
      }
    ]
  },
  {
    path: "",
    component: Layout,
    name: "placeOrder",
    redirect: "/placeOrder",
    children: [
      {
        path: "/placeOrder",
        component: () => import("@/views/placeOrder/placeOrder"),
        name: "placeOrder"
      }
    ]
  },
  {
    path: "/test",
    component: () => import("@/views/test/test"),
    hidden: true
  },
  {
    path: "/404",
    component: () => import("@/views/error-page/404"),
    hidden: true
  },
  {
    path: "/305",
    component: () => import("@/views/error-page/305"),
    hidden: true
  },
  {
    path: "/helpAndSupport",
    component: Layout,
    redirect: "/helpAndSupport/helpCenter",
    name: "helpAndSupport",
    children: [
      {
        path: "/helpAndSupport/helpCenter",
        component: () => import("@/views/helpAndSupport/help-center"),
        name: "helpCenter"
      },
      {
        path: "/helpAndSupport/helpManual",
        component: () =>
          import("@/views/helpAndSupport/manual/help-apply-usersmanual"),
        name: "helpManual"
      },
      {
        path: "/helpAndSupport/helpProblem",
        component: () =>
          import("@/views/helpAndSupport/problem/problem-edit-dic"),
        name: "helpProblem"
      }
    ]
  },
  {
    path: "*",
    redirect: "404"
  }
];

export default new Router({
  mode: "history", // require service support
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
});
